export const UNIT_SYSTEM = {
  METRIC: "metric",
  IMPERIAL: "imperial",
};

export const normalizeUnitSystem = (value) => (
  value === UNIT_SYSTEM.IMPERIAL ? UNIT_SYSTEM.IMPERIAL : UNIT_SYSTEM.METRIC
);

export const formatDistanceKm = (kilometers, unitSystem = UNIT_SYSTEM.METRIC) => {
  if (kilometers == null || !Number.isFinite(Number(kilometers))) return null;
  const value = Number(kilometers);
  if (normalizeUnitSystem(unitSystem) === UNIT_SYSTEM.IMPERIAL) {
    const miles = value * 0.621371;
    return `${miles >= 10 ? Math.round(miles) : Number(miles.toFixed(1))} mi`;
  }
  return `${value >= 10 ? Math.round(value) : Number(value.toFixed(1))} km`;
};
